import { render, staticRenderFns } from "./QDynamicSubmenu.vue?vue&type=template&id=163b8a88&"
import script from "./QDynamicSubmenu.vue?vue&type=script&lang=js&"
export * from "./QDynamicSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./QDynamicSubmenu.vue?vue&type=style&index=0&id=163b8a88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports